<nav aria-label="breadcrumb">
  <ol class="breadcrumb bg-transparent px-0 py-1 mb-0">
    <li class="breadcrumb-item">
      @if (isAdmin) {
        <a routerLink="/dashboard/project/list">Projects</a>
      } @else {
        Projects
      }
    </li>
    <li class="breadcrumb-item">{{ project?.name || 'Project' }}</li>
    <li class="breadcrumb-item active" aria-current="page">Media Imports</li>
  </ol>
</nav>
<div class="pagetitle">
  <h2>Media Imports</h2>
</div>
<p class="small text-muted text-left imports-intro">JSON exports uploaded to {{ project?.name || 'this project' }}. Select a row to open its JSON.</p>
<alert></alert>

<div class="import-summary row">
  <div class="col-6 col-lg mb-3">
    <button type="button" class="card import-card" (click)="showStatuses(['queued', 'processing'])">
      <span class="card-label">In Progress <i class="fa fa-chevron-right" aria-hidden="true"></i></span>
      <span class="card-value">{{ summary ? (countOf('queued', 'processing') | number) : '—' }}</span>
      <span class="card-detail">{{ summary ? inProgressDetail : '' }}</span>
    </button>
  </div>
  <div class="col-6 col-lg mb-3">
    <button type="button" class="card import-card" (click)="showStatuses(['completed'])">
      <span class="card-label">Completed <i class="fa fa-chevron-right" aria-hidden="true"></i></span>
      <span class="card-value">{{ summary ? (countOf('completed') | number) : '—' }}</span>
      <span class="card-detail">Indexed and searchable</span>
    </button>
  </div>
  <div class="col-6 col-lg mb-3">
    <button type="button" class="card import-card" [class.border-danger]="countOf('failed') > 0" (click)="showStatuses(['failed'])">
      <span class="card-label">Failed <i class="fa fa-chevron-right" aria-hidden="true"></i></span>
      <span class="card-value" [class.text-danger]="countOf('failed') > 0">{{ summary ? (countOf('failed') | number) : '—' }}</span>
      <span class="card-detail">Rolled back automatically</span>
    </button>
  </div>
  <div class="col-6 col-lg mb-3">
    <div class="card import-card bg-light">
      <span class="card-label">Files Imported</span>
      <span class="card-value">{{ summary ? (summary.completedFileCount | number) : '—' }}</span>
      <span class="card-detail">{{ summary ? 'Across ' + plural(countOf('completed'), 'completed import') : '' }}</span>
    </div>
  </div>
  <div class="col-6 col-lg mb-3">
    <div class="card import-card bg-light">
      <span class="card-label">Total Size</span>
      <span class="card-value">{{ summary ? (summary.completedFileSize | formatBytes) : '—' }}</span>
      <span class="card-detail">Referenced by those files</span>
    </div>
  </div>
</div>

@if (isAdmin) {
  <app-import-upload [projectId]="projectId" (uploaded)="onUploaded($event)"></app-import-upload>
}

<div class="form-row align-items-center">
  <div class="col-md-6 mb-2">
    <input type="search" class="form-control form-control-sm" placeholder="Search file names" aria-label="Search file names" [value]="query.search || ''" (input)="onSearch($event.target.value)">
  </div>
  <div class="col-md-6 mb-2 text-md-right">
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openFilters()">
      <i class="fa fa-fw fa-filter"></i> Filters
      @if (activeFilterCount) {
        <span class="badge badge-primary ml-1">{{ activeFilterCount }}</span>
      }
    </button>
  </div>
</div>

@if (chips.length) {
  <div class="filter-chips d-flex flex-wrap align-items-center mb-2">
    <span class="small text-muted mr-2">Active filters:</span>
    @for (chip of chips; track chip.label) {
      <span class="badge badge-light border mr-1">{{ chip.label }}: {{ chip.text }}</span>
    }
    <button type="button" class="btn btn-sm btn-link" (click)="clearFilters()"><i class="fa fa-fw fa-times"></i> Clear all</button>
  </div>
}

@if (isAdmin && selected.size) {
  <div class="d-flex align-items-center justify-content-between border rounded px-3 py-2 mb-2">
    <span><strong>{{ selected.size }}</strong> selected</span>
    <div>
      <button type="button" class="btn btn-sm btn-link" [disabled]="deleting" (click)="selected.clear()">Clear selection</button>
      <button type="button" class="btn btn-sm btn-danger" [disabled]="deleting" (click)="deleteSelected()"><i class="fa fa-fw fa-trash"></i> Delete selected ({{ selected.size }})</button>
    </div>
  </div>
}

<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" width="100%" cellspacing="0">
    <thead>
      <tr>
        @if (isAdmin) {
          <th width="36" class="sort-na text-center">
            <input type="checkbox" aria-label="Select all deletable imports on this page" [checked]="allSelected" [disabled]="deleting || !imports.some(isDeletable)" (change)="toggleAll()">
          </th>
        }
        <th [ngClass]="sortClass('fileName')" [attr.aria-sort]="ariaSort('fileName')"><button type="button" class="sort-button" (click)="sort('fileName')">File</button></th>
        <th [ngClass]="sortClass('status')" [attr.aria-sort]="ariaSort('status')"><button type="button" class="sort-button" (click)="sort('status')">Status</button></th>
        <th class="text-right" [ngClass]="sortClass('totalFileCount')" [attr.aria-sort]="ariaSort('totalFileCount')"><button type="button" class="sort-button" (click)="sort('totalFileCount')">Files</button></th>
        <th class="text-right" [ngClass]="sortClass('totalFileSize')" [attr.aria-sort]="ariaSort('totalFileSize')"><button type="button" class="sort-button" (click)="sort('totalFileSize')">Size</button></th>
        <th [ngClass]="sortClass('startedAt')" [attr.aria-sort]="ariaSort('startedAt')"><button type="button" class="sort-button" (click)="sort('startedAt')">Started</button></th>
        @if (isAdmin) {
          <th width="200" class="sort-na">Action</th>
        }
      </tr>
    </thead>
    <tbody>
      @if (loading || msg) {
        <tr><td [attr.colspan]="isAdmin ? 7 : 5" class="loading text-center">{{ loading ? 'Loading...' : msg }}</td></tr>
      }
      @for (row of imports; track row.id) {
        <tr [class.clickable]="hasJson(row)" (click)="open($event, row)">
          @if (isAdmin) {
            <td class="text-center">
              @if (isDeletable(row)) {
                <input type="checkbox" [attr.aria-label]="'Select ' + row.fileName" [checked]="selected.has(row.id)" [disabled]="deleting" (change)="toggle(row.id)">
              }
            </td>
          }
          <td class="text-break">
            @if (hasJson(row)) {
              <a class="font-weight-bold" [routerLink]="['/dashboard/project', projectId, 'imports', row.id, 'json']">{{ row.fileName }}</a>
            } @else {
              <span class="font-weight-bold">{{ row.fileName }}</span>
            }
            @if (row.status === 'failed' && row.errorMessage) {
              <div class="small text-danger">{{ row.errorMessage }}</div>
            }
          </td>
          <td>
            <span class="badge {{ badgeClass(row.status) }}">{{ statusLabel[row.status] }}</span>
            @if (showsProgress(row.status)) {
              <div class="d-flex align-items-center small text-muted mt-1">
                <div class="progress import-progress mr-2">
                  <div class="progress-bar" role="progressbar" [style.width.%]="row.progress" [attr.aria-valuenow]="row.progress" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                {{ row.progress }}%
              </div>
            }
          </td>
          <td class="text-right">{{ isTotalKnown(row.totalFileCount, row.status) ? (row.totalFileCount | number) : '—' }}</td>
          <td class="text-right">{{ isTotalKnown(row.totalFileSize, row.status) ? (row.totalFileSize | formatBytes) : '—' }}</td>
          <td>
            <div>{{ row.startedAt | date:'MM/dd/yyyy, h:mm a' }}</div>
            <div class="small text-muted">{{ startedDetail(row) }}</div>
          </td>
          @if (isAdmin) {
            <td class="text-center">
              @if (hasJson(row)) {
                <button type="button" class="btn btn-secondary btn-xs" (click)="downloadSource(row)" title="Download the export's JSON"><i class="fas fa-download"></i> JSON</button>&nbsp;
              }
              @for (action of importActions(row.status); track action) {
                <button type="button" class="btn btn-xs" [ngClass]="action === 'delete' || action === 'cancel' ? 'btn-delete' : 'btn-edit'" (click)="act(action, row)">{{ actionLabel[action] }}</button>&nbsp;
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

@if (count) {
  <div class="d-flex flex-wrap align-items-center mb-3">
    <span class="mr-3">Showing {{ query.offset + 1 }} to {{ query.offset + imports.length }} of {{ count | number }}</span>
    <select class="form-control form-control-sm w-auto mr-3" aria-label="Page size" (change)="setPageSize($event.target.value)">
      @for (size of pageSizes; track size) {
        <option [value]="size" [selected]="size === query.limit">{{ size }} per page</option>
      }
    </select>
    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="query.offset === 0" (click)="page(-1)">Previous</button>
    <span class="mx-2">
      Page <input #pageInput type="number" class="form-control form-control-sm d-inline-block page-input" aria-label="Go to page" min="1" [max]="pages" [value]="pageNumber" (change)="goToPage(pageInput)"> of {{ pages }}
    </span>
    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="query.offset + query.limit >= count" (click)="page(1)">Next</button>
  </div>
}

<ng-template #filtersDialog let-modal>
  <div class="modal-header">
    <h3 class="modal-title">Filter Media Imports</h3>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-left">
    <p class="small text-muted">Narrow the list by status, media, size, timing or duration. Blank bounds are open-ended.</p>
    <fieldset class="form-group">
      <legend class="col-form-label pt-0">Status</legend>
      @for (s of statuses; track s[0]) {
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" [id]="'filter-status-' + s[0]" [checked]="draft.status.includes(s[0])" (change)="toggleIn(draft.status, s[0])">
          <label class="form-check-label" [for]="'filter-status-' + s[0]">{{ s[1] }}</label>
        </div>
      }
    </fieldset>
    <fieldset class="form-group">
      <legend class="col-form-label pt-0">Media</legend>
      @if (mediaError) {
        <div class="small text-muted">Couldn't load media</div>
      } @else if (!media) {
        <div class="small text-muted">Loading media…</div>
      } @else if (!media.length) {
        <div class="small text-muted">No media in this project</div>
      } @else {
        <div class="media-options">
          @for (m of media; track m.id; let i = $index) {
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" [id]="'filter-media-' + i" [checked]="draft.mediaId.includes(m.id)" (change)="toggleIn(draft.mediaId, m.id)">
              <label class="form-check-label" [for]="'filter-media-' + i">{{ m.label }}</label>
            </div>
          }
        </div>
      }
    </fieldset>
    <div class="form-row">
      @for (range of ranges; track range.label) {
        <div class="form-group col-md-4">
          <label class="mb-1" [for]="'filter-' + range.min">{{ range.label }}{{ range.unit ? ' (' + range.unit + ')' : '' }}</label>
          <div class="form-row">
            <div class="col">
              <input type="number" class="form-control form-control-sm" [id]="'filter-' + range.min" min="0" [step]="range.step" placeholder="Min" [attr.aria-label]="range.label + ' minimum'" [(ngModel)]="draft[range.min]">
            </div>
            <div class="col">
              <input type="number" class="form-control form-control-sm" min="0" [step]="range.step" placeholder="Max" [attr.aria-label]="range.label + ' maximum'" [(ngModel)]="draft[range.max]">
            </div>
          </div>
        </div>
      }
    </div>
    <div class="form-row">
      @for (range of dateRanges; track range.label) {
        <div class="form-group col-md-6">
          <label class="mb-1" [for]="'filter-' + range.from">{{ range.label }}</label>
          <div class="form-row">
            <div class="col input-group input-group-sm">
              <input class="form-control" [id]="'filter-' + range.from" placeholder="mm/dd/yyyy" [attr.aria-label]="range.label + ' from'" ngbDatepicker #fromPicker="ngbDatepicker" [(ngModel)]="draft[range.from]">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" [attr.aria-label]="'Pick the first day ' + range.label.toLowerCase()" (click)="fromPicker.toggle()"><i class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div class="col input-group input-group-sm">
              <input class="form-control" placeholder="mm/dd/yyyy" [attr.aria-label]="range.label + ' to'" ngbDatepicker #toPicker="ngbDatepicker" [(ngModel)]="draft[range.to]">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" [attr.aria-label]="'Pick the last day ' + range.label.toLowerCase()" (click)="toPicker.toggle()"><i class="fa fa-calendar"></i></button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (draftInvalid) {
      <p class="small text-danger mb-0">Each minimum must be at or below its maximum, no bound can be negative, each start date must be a mm/dd/yyyy date at or before its end date, and up to 20 media can be picked.</p>
    }
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-sm btn-link" (click)="clearDraft()">Clear filters</button>
    <div>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-sm btn-primary ml-1" [disabled]="draftInvalid" (click)="applyFilters()">Apply filters</button>
    </div>
  </div>
</ng-template>
